import React from "react";
import { Star } from "lucide-react";

export function StarRating({ value = 0, size = "w-4 h-4", interactive = false, onChange }) {
  return (
    <div className="flex items-center gap-0.5" data-testid={interactive ? "star-rating-input" : "star-rating"}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          disabled={!interactive}
          onClick={() => interactive && onChange?.(i)}
          className={interactive ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"}
          data-testid={interactive ? `star-${i}` : undefined}
          aria-label={`${i} star`}
        >
          <Star className={`${size} ${i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
        </button>
      ))}
    </div>
  );
}
